import { createApplier } from '@/app/libs/I';

/**
 * @deprecated legacy
 */
export namespace storeService {
  /**
   * @deprecated legacy
   */
  export const applierId = Symbol('store-service');
  /**
   * @deprecated legacy
   */
  export const apply = createApplier(applierId);
}
